import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ampli } from '../../../../../ampli';
import { Icon } from '../../../../../components/common/icon/Icon';
import { IProduct } from '../../../../../interfaces/Product.interfaces';
import { SectionTitle } from './SectionTitle';

interface ProductPurchaseTipSectionProps {
  product: IProduct;
}

export const ProductPurchaseTipSection = ({ product }: ProductPurchaseTipSectionProps) => {
  const navigate = useNavigate();

  return (
    <Container>
      <SectionTitle>{'받을 수 있는 금융 혜택'}</SectionTitle>
      <AdditionalInfoSection>
        <AdditionalInfoCard
          onClick={() => {
            ampli.마켓매물상세페이지할부구매가궁금하신가요버튼클릭({
              '게시글 제목': product.title ?? '',
            });
            navigate('/info/cbe88610-361c-4cda-b2bd-40c3709a759e');
          }}
        >
          <AdditionalInfoCardLeftSection>
            <AdditionalInfoCardTitleAndContentWrap>
              <AdditionalInfoCardTitle>{'플루바 할부 상세 안내를 알아보세요!'}</AdditionalInfoCardTitle>
            </AdditionalInfoCardTitleAndContentWrap>
          </AdditionalInfoCardLeftSection>
          <AdditionalInfoCardRightSection>
            <Icon name={'ArrowRightSmall'} width={10} height={10} />
          </AdditionalInfoCardRightSection>
        </AdditionalInfoCard>
        <AdditionalInfoCard
          onClick={() => {
            ampli.마켓매물상세페이지융자확인에대한기본지식을알려드릴께요버튼클릭({
              '게시글 제목': product.title ?? '',
            });
            navigate('/info/6f7f1fc8-85ce-40b0-8447-6b0ac2a9c43d');
          }}
        >
          <AdditionalInfoCardLeftSection>
            <AdditionalInfoCardTitleAndContentWrap>
              <AdditionalInfoCardTitle>{'농협 중고 농기계 구입자금(융자)이 궁금하신가요?'}</AdditionalInfoCardTitle>
              <AdditionalInfoCardDescription>{'플루바 할부와 함께 받으면 두배의 혜택!'}</AdditionalInfoCardDescription>
            </AdditionalInfoCardTitleAndContentWrap>
          </AdditionalInfoCardLeftSection>
          <AdditionalInfoCardRightSection>
            <Icon name={'ArrowRightSmall'} width={10} height={10} />
          </AdditionalInfoCardRightSection>
        </AdditionalInfoCard>
        <AdditionalInfoCard
          onClick={() => {
            ampli.마켓매물상세페이지농기계보험지원내용을확인해보세요버튼클릭({
              '게시글 제목': product.title ?? '',
            });
            navigate('/info/8b6c4be1-3cf5-4faa-943b-888336393a82');
          }}
        >
          <AdditionalInfoCardLeftSection>
            <AdditionalInfoCardTitleAndContentWrap>
              <AdditionalInfoCardTitle>{'농협 농기계 보험 지원 안내!'}</AdditionalInfoCardTitle>
            </AdditionalInfoCardTitleAndContentWrap>
          </AdditionalInfoCardLeftSection>
          <AdditionalInfoCardRightSection>
            <Icon name={'ArrowRightSmall'} width={10} height={10} />
          </AdditionalInfoCardRightSection>
        </AdditionalInfoCard>
      </AdditionalInfoSection>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding: 32px var(--radius-large, 16px);
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

const AdditionalInfoSection = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  gap: 16px;
`;

const AdditionalInfoCard = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: var(--radius-medium, 8px) 0px;

  gap: var(--radius-large, 16px);

  cursor: pointer;
`;

const AdditionalInfoCardLeftSection = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  gap: 16px;
`;

const AdditionalInfoCardRightSection = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const AdditionalInfoCardTitleAndContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
`;

const AdditionalInfoCardTitle = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Body/Large/l-medium */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
`;

const AdditionalInfoCardDescription = styled.span`
  color: var(--Light-Scheme-Monochrome-grey100, #858894);

  /* Body/Small/s-regular */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 18px */
`;
